import Scriba from 'react-scriba';

export class DataSouhait {
    static _onChargementDroitsSouhait() {
        var url = "api/Droit/ListeDesDroitsFicheSouhait";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementSouhait(idContact, idSouhait, souhait) {
        let objet = {
            "idContact": idContact,
            "idSouhait": idSouhait,
            "souhait": souhait
        };

        var url = "api/MAJDonnees/EnregistrementSouhait";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementAlarme(idContactChiffre, idSouhait, alarme) {
        const objet = { idContactChiffre, idSouhait, alarme };
        const url = "api/MAJDonnees/EnregistrementAlarme";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _onChargementSouhaitMaisonIndividuelle(idContact, idSouhait) {
        let objet = {
            "idContact": idContact,
            "idSouhait": idSouhait
        };

        var url = "api/Fiche/FicheSouhait_MaisonIndividuelle";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementSouhaitMaisonIndividuelle(idContact, idSouhait, souhait) {
        let objet = {
            "idContact": idContact,
            "idSouhait": idSouhait,
            "souhait": souhait
        };

        var url = "api/MAJDonnees/EnregistrementSouhait_MaisonIndividuelle";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheSouhaitEnModeModification(idContact, idSouhait) {
        let objet = {
            "idContact": idContact,
            "idSouhait": idSouhait
        };

        let url = "api/Fiche/FicheSouhait";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheSouhaitEnModeCreation() {

        let url = "api/Droit/ListeDesDroitsFicheSouhait";
        let paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionSouhait(idContact, idSouhait) {
        var objet = {
            "idContact": idContact,
            "idSouhait": idSouhait
        }

        var url = "api/MAJDonnees/SuppressionSouhait";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesSouhaits(idContact, facteurNbreEnregistrement, pageIndex, recherche, tri, selectionIdContactIdSouhait, appelDepuisReservation, idOperation, idReservation, filtreNomContact,
        filtreIdSociete, filtreLoginCompte, filtreRechercheMotifAcquisition, filtreIdOperation, filtreIdVilleAdministrative, filtreRechercheOrigineCommerciale, filtreSuiviCommercialTrav,
        filtreDateDernierSuiviCommercialMin, filtreDateDernierSuiviCommercialMax, filtreProchaineAlarmeMinTrav, filtreProchaineAlarmeMaxTrav,
        filtreNonReserves, filtreRDV1, filtreRDV2, filtreRDV3, filtreMinJourDernierSuiviCommercialOuRdv, filtreMaxJourDernierSuiviCommercialOuRdv) {

        let objet = {
            "idContact": idContact,
            "nbreEnreg": facteurNbreEnregistrement,
            "pageIndex": pageIndex,
            "recherche": recherche,
            "tri": tri,
            "selectionIdContactIdSouhait": selectionIdContactIdSouhait,
            "appelDepuisReservation": appelDepuisReservation,
            "idOperation": idOperation,
            "idReservation": idReservation,
            "filtreNomContact": filtreNomContact,
            "filtreIdSociete": filtreIdSociete,
            "filtreLoginCompte": filtreLoginCompte,
            "filtreRechercheMotifAcquisition": filtreRechercheMotifAcquisition,
            "filtreIdOperation": filtreIdOperation,
            "filtreIdVilleAdministrative": filtreIdVilleAdministrative,
            "filtreRechercheOrigineCommerciale": filtreRechercheOrigineCommerciale,
            "filtreSuiviCommercial": filtreSuiviCommercialTrav,
            "filtreDateDernierSuiviCommercialMin": filtreDateDernierSuiviCommercialMin,
            "filtreDateDernierSuiviCommercialMax": filtreDateDernierSuiviCommercialMax,
            "filtreProchaineAlarmeMin": filtreProchaineAlarmeMinTrav,
            "filtreProchaineAlarmeMax": filtreProchaineAlarmeMaxTrav,
            "filtreNonReserves": filtreNonReserves,
            "filtreRDV1": filtreRDV1,
            "filtreRDV2": filtreRDV2,
            "filtreRDV3": filtreRDV3,
            "filtreMinJourDernierSuiviCommercialOuRdv": filtreMinJourDernierSuiviCommercialOuRdv,
            "filtreMaxJourDernierSuiviCommercialOuRdv": filtreMaxJourDernierSuiviCommercialOuRdv,
        };

        var url = "api/Liste/ListeDesSOUHAITS";

        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementDesSouhaitsMaisonIndividuelle(idContact, facteurNbreEnregistrement, pageIndex, recherche, tri, selectionIdContactIdSouhait, appelDepuisReservation, filtreNomContact, filtreDateR2) {

        let objet = {
            "idContact": idContact,
            "nbreEnreg": facteurNbreEnregistrement,
            "recherche": recherche,
            "tri": tri,
            "pageIndex": pageIndex,
            "selectionIdContactIdSouhait": selectionIdContactIdSouhait,
            "appelDepuisReservation": appelDepuisReservation,
            "souhaitMaisonIndividuelle": true,
            "filtreNomContact": filtreNomContact,
            "filtreDateR2": filtreDateR2
        };

        var url = "api/Liste/ListeDesSOUHAITS";

        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

}